import { useState } from "react";
import { useLogin } from "../hooks/useAuth";

/**
 * Login screen.
 *
 * Goal: looks like a real product the moment your brother-in-law shares
 * the URL with a client. Big TRULY mark, calm beige background,
 * single-field focus.
 */
export function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const login = useLogin();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    login.mutate(
      { username, password },
      {
        onSuccess: () => {
          // Honor ?next= so refreshing a deep link still works.
          const params = new URLSearchParams(window.location.search);
          const next = params.get("next") || "/";
          window.location.replace(next);
        },
      },
    );
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-beige p-6">
      <div className="w-full max-w-sm">
        <div className="mb-10 text-center">
          <h1 className="headline text-7xl text-brand-text-dark">TRULY</h1>
          <p className="mt-2 text-xs font-bold uppercase tracking-[0.3em] text-brand-text-dark/50">
            Cockpit
          </p>
        </div>

        <form
          onSubmit={onSubmit}
          className="space-y-4 rounded-2xl bg-white p-6 shadow-lg shadow-black/5 ring-1 ring-black/5"
        >
          <Field label="Benutzername">
            <input
              type="text"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input-base"
            />
          </Field>

          <Field label="Passwort">
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-base"
            />
          </Field>

          {login.error ? (
            <div className="rounded-lg bg-red-50 px-3 py-2 text-xs text-red-900">
              {String(login.error.message || login.error).includes("401")
                ? "Falsche Zugangsdaten."
                : String(login.error)}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={login.isPending || !username || !password}
            className="w-full rounded-full bg-brand-blue px-6 py-3 text-sm font-bold uppercase tracking-wider text-brand-cream shadow-lg shadow-brand-blue/30 transition hover:bg-brand-blue-deep disabled:cursor-not-allowed disabled:opacity-50"
          >
            {login.isPending ? "Anmelden…" : "Anmelden"}
          </button>
        </form>

        <p className="mt-6 text-center text-[11px] text-brand-text-dark/40">
          Demo-Cockpit · TRULY · Studio Y-si GmbH
        </p>
      </div>

      <style>{`
        .input-base {
          display: block;
          width: 100%;
          border-radius: 0.75rem;
          border: 1px solid rgb(0 0 0 / 0.1);
          background: white;
          padding: 0.625rem 0.875rem;
          font-size: 0.875rem;
          color: var(--color-brand-text-dark);
          transition: border-color 120ms;
        }
        .input-base:focus {
          border-color: var(--color-brand-blue);
          outline: none;
        }
      `}</style>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <div className="mb-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-text-dark/70">
        {label}
      </div>
      {children}
    </label>
  );
}
